import Crud from '../components/Detatched/Crud'
import Detatched from '../components/Detatched/Detatched'

let routes = {
    path: '/detatcheds',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/detatcheds',
            name: 'Avulsos',
            component: Crud
        },
        {
            path: '/detatched/:id?',
            name: 'Avulso',
            component: Detatched
        },
    ]
}

export default routes


// WEBPACK FOOTER //
// ./src/router/detatched.js